<template>
  <div>
    <el-dialog title="账号共享" :visible="visible" width="980px" append-to-body :close-on-click-modal="false" @update:visible="$emit('update:visible', $event)" @open="open">
      <el-tabs v-model="tab" @tab-click="loadTab">
        <el-tab-pane label="共享给其他账号" name="sent">
          <el-alert title="接收账号只能查看所选运单，不包含未来新单，也不能修改或再次分享。" type="info" :closable="false" show-icon />
          <div class="share-form">
            <span>已选 {{ waybills.length }} 张运单</span>
            <el-select v-model="receiverUserId" filterable remote clearable :remote-method="searchAccounts" :loading="accountsLoading" placeholder="输入接收账号" @focus="searchAccounts('')"><el-option v-for="account in accounts" :key="account.id" :label="account.username" :value="account.id" /></el-select>
            <el-button type="primary" :loading="saving" :disabled="!waybills.length || !receiverUserId" v-permission="'waybill:share'" @click="share">确认共享</el-button>
          </div>
          <div class="received-actions"><span>查看所选运单的授权记录</span><el-select v-model="sentTransportNo" size="small" placeholder="请先在列表选择运单" @change="loadTab"><el-option v-for="row in waybills" :key="row.waybillNo" :label="row.waybillNo" :value="row.waybillNo" /></el-select></div>
          <el-table v-loading="loading" :data="sent" border size="small" empty-text="暂无发出的共享">
            <el-table-column prop="transportNo" label="运单号" min-width="180" show-overflow-tooltip />
            <el-table-column prop="receiverUsername" label="接收账号" min-width="150" />
            <el-table-column label="共享时间" width="170"><template slot-scope="{ row }">{{ formatDate(row.createdTime) }}</template></el-table-column>
            <el-table-column label="状态" width="90"><template slot-scope="{ row }">{{ row.revokedTime ? '已撤销' : '共享中' }}</template></el-table-column>
            <el-table-column label="操作" width="100"><template slot-scope="{ row }"><el-button type="text" :disabled="!!row.revokedTime" :loading="revoking === row.id" v-permission="'waybill:share'" @click="revoke(row)">撤销共享</el-button></template></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="共享给我的运单" name="received">
          <div class="received-actions"><span>当前账号收到的只读运单</span><el-button size="small" icon="el-icon-refresh" @click="loadTab">刷新</el-button></div>
          <el-table v-loading="loading" :data="received" border size="small" empty-text="暂无收到的共享">
            <el-table-column prop="transportNo" label="运单号" min-width="170" show-overflow-tooltip />
            <el-table-column prop="vehicleNo" label="车牌" width="120" />
            <el-table-column prop="ownerUsername" label="共享账号" width="130" />
            <el-table-column prop="startAddress" label="起点" min-width="160" show-overflow-tooltip />
            <el-table-column prop="endAddress" label="目的地" min-width="160" show-overflow-tooltip />
            <el-table-column label="操作" width="160" fixed="right"><template slot-scope="{ row }"><el-button type="text" :loading="opening === row.id" v-permission="['waybill:monitor', 'fullmap:view']" @click="viewReceived(row)">查看轨迹</el-button><el-button type="text" v-permission="['waybill:monitor', 'fullmap:view']" @click="viewEvents(row)">行程事件</el-button></template></el-table-column>
          </el-table>
          <el-pagination class="received-pagination" :current-page="page" :page-size="15" :total="total" layout="total, prev, pager, next" @current-change="changePage" />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <waybill-map-dialog v-if="viewerVisible" :visible.sync="viewerVisible" :waybill="detail.waybill" :stopovers="detail.stopovers || []" share-mode share-scope="FULL_TRIP" :initial-monitor-data="monitorData" :initial-alarms="alarms" :initial-route-plan="detail.route || null" :initial-fences="detail.fences || []" :share-refresh-handler="loadReceivedTracks" />
    <el-dialog :title="eventTransportNo + ' · 行程事件'" :visible.sync="eventsVisible" width="720px" append-to-body>
      <el-table v-loading="eventsLoading" :data="events" border size="small" empty-text="暂无行程事件">
        <el-table-column prop="nodeName" label="节点" min-width="150" show-overflow-tooltip />
        <el-table-column label="事件" width="170"><template slot-scope="{ row }">{{ eventText(row.nodeType) }}</template></el-table-column>
        <el-table-column label="发生时间" width="180"><template slot-scope="{ row }">{{ formatDate(row.eventTime) }}</template></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { createAccountShares, getAccountShareUsers, getAccountShares, getReceivedWaybills, getReceivedWaybillData, revokeAccountShare, isRequestSuccess } from './lingdongApi'
import WaybillMapDialog from './WaybillMapDialog.vue'

export default {
  name: 'WaybillAccountShare',
  components: { WaybillMapDialog },
  props: { visible: Boolean, waybills: { type: Array, default: () => [] } },
  data() {
    return { tab: 'sent', sentTransportNo: '', receiverUserId: null, accounts: [], accountsLoading: false, saving: false, loading: false, sent: [], received: [], page: 1, total: 0, revoking: null, opening: null, viewerVisible: false, selectedShareId: null, detail: {}, monitorData: null, alarms: [], requestId: 0, accountRequestId: 0, viewerRequestId: 0, eventRequestId: 0, eventsVisible: false, eventsLoading: false, events: [], eventTransportNo: '' }
  },
  beforeDestroy() { this.requestId += 1; this.accountRequestId += 1; this.viewerRequestId += 1; this.eventRequestId += 1 },
  methods: {
    open() { this.tab = this.waybills.length ? 'sent' : 'received'; this.sentTransportNo = this.waybills.length ? this.waybills[0].waybillNo : ''; this.receiverUserId = null; this.page = 1; this.loadTab() },
    async searchAccounts(keyword) {
      const id = ++this.accountRequestId
      this.accountsLoading = true
      try {
        const res = await getAccountShareUsers({ keyword })
        if (id !== this.accountRequestId) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '获取账号失败')
        this.accounts = res.data || []
      } catch (error) { if (id === this.accountRequestId) this.$message.error(error.msg || error.message || '获取账号失败') } finally { if (id === this.accountRequestId) this.accountsLoading = false }
    },
    async loadTab() {
      const id = ++this.requestId
      const tab = this.tab
      if (tab === 'sent' && !this.sentTransportNo) { this.sent = []; this.loading = false; return }
      this.loading = true
      try {
        const res = tab === 'sent' ? await getAccountShares({ transportNo: this.sentTransportNo }) : await getReceivedWaybills({ page: this.page, pageSize: 15 })
        if (id !== this.requestId) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '获取共享记录失败')
        if (tab === 'sent') this.sent = res.data || []
        else { this.received = res.data.items || []; this.total = Number(res.data.total || 0) }
      } catch (error) { if (id === this.requestId) this.$message.error(error.msg || error.message || '获取共享记录失败') } finally { if (id === this.requestId) this.loading = false }
    },
    changePage(page) { this.page = page; this.loadTab() },
    async share() {
      if (!this.waybills.length || !this.receiverUserId || this.saving) return
      this.saving = true
      try {
        const res = await createAccountShares({ transportNos: this.waybills.map(row => row.waybillNo), receiverUserId: this.receiverUserId })
        if (!isRequestSuccess(res)) throw new Error(res.msg || '共享失败')
        this.$message.success('已共享给指定账号')
        await this.loadTab()
      } catch (error) { this.$message.error(error.msg || error.message || '共享失败') } finally { this.saving = false }
    },
    async revoke(row) {
      try {
        await this.$confirm(`确认撤销运单「${row.transportNo}」给 ${row.receiverUsername} 的共享？`, '撤销共享', { type: 'warning' })
        this.revoking = row.id
        const res = await revokeAccountShare(row.id)
        if (!isRequestSuccess(res)) throw new Error(res.msg || '撤销失败')
        this.$message.success('共享已撤销')
        await this.loadTab()
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || error.message || '撤销失败') } finally { this.revoking = null }
    },
    async viewReceived(row) {
      const id = ++this.viewerRequestId
      this.opening = row.id
      this.viewerVisible = false
      try {
        const [detail, tracks, alarms] = await Promise.all(['detail', 'tracks', 'alarms'].map(resource => getReceivedWaybillData(row.id, resource, { limit: 2000 })))
        if (id !== this.viewerRequestId) return
        ;[detail, tracks, alarms].forEach(res => { if (!isRequestSuccess(res)) throw new Error(res.msg || '读取共享运单失败') })
        this.selectedShareId = row.id
        this.detail = detail.data
        this.monitorData = tracks.data
        this.alarms = alarms.data || []
        this.viewerVisible = true
      } catch (error) { if (id === this.viewerRequestId) this.$message.error(error.msg || error.message || '读取共享运单失败') } finally { if (id === this.viewerRequestId) this.opening = null }
    },
    async viewEvents(row) {
      const id = ++this.eventRequestId
      this.eventTransportNo = row.transportNo
      this.events = []
      this.eventsVisible = true
      this.eventsLoading = true
      try {
        const res = await getReceivedWaybillData(row.id, 'journeyNodes')
        if (id !== this.eventRequestId) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '获取行程事件失败')
        this.events = res.data || []
      } catch (error) { if (id === this.eventRequestId) this.$message.error(error.msg || error.message || '获取行程事件失败') } finally { if (id === this.eventRequestId) this.eventsLoading = false }
    },
    eventText(type) { return { START_ARRIVED: '进入起点围栏', START_DEPARTED: '驶出起点围栏', DESTINATION_ARRIVED: '进入目的地围栏', DESTINATION_DEPARTED: '驶出目的地围栏', STOPOVER_ARRIVED: '进入经停点', STOPOVER_DEPARTED: '驶出经停点' }[type] || type || '-' },
    async loadReceivedTracks(params) {
      const res = await getReceivedWaybillData(this.selectedShareId, 'tracks', params)
      if (!isRequestSuccess(res)) throw new Error(res.msg || '读取共享轨迹失败')
      return res.data
    },
    formatDate(value) { return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-' }
  }
}
</script>

<style scoped>
.share-form { display: flex; gap: 14px; align-items: center; margin: 18px 0; }
.received-actions { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; color: #909399; font-size: 13px; }
.received-pagination { margin-top: 18px; text-align: right; }
</style>
